import React from "react";
import { FaMobileAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdInsights } from "react-icons/md";
import "./VisualizationSection4.css";

const steps = [
  {
    id: 1,
    icon: <FaLocationDot />,
    title: "Review your mood by location",
    text: "Happimeter uses Machine Learning to predict your mood, activation and stress level. It learns based on your inputs and sensor data gained from your smartwatch.",
  },
  {
    id: 2,
    icon: <FaMobileAlt />,
    title: "Track your mood",
    text: "Answer questions about your mood and stress level",
  },
  {
    id: 3,
    icon: <MdInsights />,
    title: "Gain insights",
    text: "See cool statistics about your mood history and see what affects your mood",
  },
];

const VisualizationSection4 = () => {
  return (
    <section className="visualization-section body.app4-page">
      {/* Section Header */}
      <h2 className="section-title">How it works?</h2>
      <p className="section-subheader">
       First of all, you need an Apple Watch or WearOS smartwach. Second, install the Happimeter app on your watch and install the companion app on your smartphone (iOS/Android).
      </p>

      {/* Steps Cards */}
      <div className="steps-container">
        {steps.map((step) => (
          <div key={step.id} className="step-card">
            <div className="step-number">{step.id}</div>
            <div className="step-icon">{step.icon}</div>
            <h4 className="step-title">{step.title}</h4>
            <p className="step-text">{step.text}</p>
          </div>
        ))}
        <div className="connecting-line"></div>
      </div>
    </section>
  );
};

export default VisualizationSection4;
